import React from "react"
import { useWindowLoadingState } from "../../../../Hooks/useWindowLoadingState"
import { MobergRow, MobergText } from "../../../../../../../../Moberg"

type WindowLoadingStateMessageProps = {
    atomKey: string
}

export const WindowLoadingStateMessage: React.FC<WindowLoadingStateMessageProps> = ({ atomKey }) => {
    const { message, progress, total } = useWindowLoadingState(atomKey)
    const pct = total > 0 ? (progress / total) * 100 : 0

    return (
        <MobergRow expand={false} gap="8px" horizontalAlign="left" style={{ width: "200px" }}>
            <span style={{ width: 40, height: 20, background: 'var(--color-chart-placeholder)', borderRadius: 2, overflow: 'hidden' }}>
                <span
                    style={{
                        display: 'block',
                        height: '100%',
                        width: `${pct}%`,
                        background: "var(--color-accent-interactive)",
                        transition: total > 0 ? 'width 0.25s ease' : 'none',
                        animation: total === 0 ? 'wli-slide 1s ease-in-out infinite' : 'none',
                    }}
                />
            </span>
            <MobergText>{message}</MobergText>
            <style>{`@keyframes wli-slide { 0%,100% { transform: translateX(-100%) } 50% { transform: translateX(150%) } }`}</style>
        </MobergRow>
    )
}
